import { CustomCellRendererWithSkeleton } from "../../components";
import {
  getReceiptPrintDate,
  getHistoryOutletName,
  getInventoryHistoryType,
  getActionColumnOfAgGridReact,
  parseToThousandSeperatorDecimalNumber,
  parseToThousandSeperatorWholeNumber,
  getCogsValue,
  getQuantityValue,
} from "../../utility";

const getInventoryHistoryTableColumns = () => {
  const isRenderContent = (params) => {
    return params?.data?.product_name;
  };
  return [
    {
      headerName: "Date",
      field: "createdOn",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          titleToolTipText={getReceiptPrintDate(params.data.createdOn)}
          componentRenderCondition={isRenderContent(params)}
          cellComponent={getReceiptPrintDate(params.data.createdOn)}
        />
      ),
    },
    {
      headerName: "Activity",
      field: "TransactionType",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          titleToolTipText={getInventoryHistoryType(params.data)}
          componentRenderCondition={isRenderContent(params)}
          cellComponent={getInventoryHistoryType(params.data)}
        />
      ),
    },
    {
      headerName: "Name",
      field: "product.name",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          titleToolTipText={params?.data?.product?.name}
          componentRenderCondition={isRenderContent(params)}
          cellComponent={params?.data?.product?.name}
        />
      ),
    },
    {
      headerName: "Type",
      field: "product.productType",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={isRenderContent(params)}
          cellComponent={params?.data?.product?.productType}
        />
      ),
    },
    {
      headerName: "Category",
      field: "product.category",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={isRenderContent(params)}
          cellComponent={params?.data?.product?.category}
        />
      ),
    },
    {
      headerTooltip: "Unit Purchase Price",
      headerName: "Unit Purchase Price",
      field: "cogs",
      cellRenderer: (params) => {
        let cogs = getCogsValue(params?.data?.product, true);
        return (
          <CustomCellRendererWithSkeleton
            params={params}
            componentRenderCondition={isRenderContent(params)}
            cellComponent={`$${parseToThousandSeperatorDecimalNumber(cogs)}`}
          />
        );
      },
    },
    {
      headerTooltip: "Unit Sell Price",
      headerName: "Unit Sell Price",
      field: "amount",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={isRenderContent(params)}
          cellComponent={`$${parseToThousandSeperatorDecimalNumber(
            params.data.amount
          )}`}
        />
      ),
    },
    {
      headerName: "Quantity",
      field: "quantity",
      cellRenderer: (params) => {
        const quantity = getQuantityValue(params?.data.product, true, true);
        return (
          <CustomCellRendererWithSkeleton
            params={params}
            componentRenderCondition={isRenderContent(params)}
            cellComponent={`${parseToThousandSeperatorWholeNumber(quantity)}`}
          />
        );
      },
    },
    {
      headerName: "Outlet",
      field: "outlet",
      cellRenderer: (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={isRenderContent(params)}
          cellComponent={getHistoryOutletName(params.data.outlet?.name)}
        />
      ),
    },
    getActionColumnOfAgGridReact(
      (params) => (
        <CustomCellRendererWithSkeleton
          params={params}
          componentRenderCondition={isRenderContent(params)}
          cellComponent={params?.data?.processedBy}
        />
      ),
      "Processed By"
    ),
  ];
};

export { getInventoryHistoryTableColumns };
